import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'loading',
  template: require('./loading.component.pug'),
  styles: [require('./loading.component.css').toString()],
})
export class LoadingComponent implements OnInit {
  public loading: boolean;

  @Input()
  text: string = 'Loading...';

  interval;
  timeLeft = 31;
  expired = false;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.loading = true;
    this.startTimer();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  // -------------------------------------------------------------------
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        if (this.timeLeft == 0) {
          this.expired = true;
          clearInterval(this.interval);
        }
      } else {
        this.timeLeft = 60;
      }
    }, 1000);
  }
}
